import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Warehouse stock transfer")])]), _c(VCardText, [_c(VForm, {
    staticClass: "dfwa-form mt-default",
    model: {
      value: _vm.addingEntity.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "valid", $$v);
      },
      expression: "addingEntity.form.valid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      label: "Departure warehouse",
      items: _vm.warehousesAvailable,
      "item-value": "id_warehouse",
      "item-text": "name",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.addingEntity.form.fromWarehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "fromWarehouseId", $$v);
      },
      expression: "addingEntity.form.fromWarehouseId"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      label: "Destination warehouse",
      items: _vm.warehousesAvailable,
      "item-value": "id_warehouse",
      "item-text": "name",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.addingEntity.form.toWarehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "toWarehouseId", $$v);
      },
      expression: "addingEntity.form.toWarehouseId"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Transfer reference",
      placeholder: "Transfer reference",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.reference,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "reference", $$v);
      },
      expression: "addingEntity.form.reference"
    }
  }), _c(VTextarea, {
    attrs: {
      label: "Comment",
      placeholder: "Explain the reason of this transfer",
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "comment", $$v);
      },
      expression: "addingEntity.form.comment"
    }
  })], 1)], 1), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntity.form.valid,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveNewEntity();
      }
    }
  }, [_vm._v(" Create pending transfer ")])], 1)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };